<template>
  <EditDialog
    v-model:visible="showModal"
    :title="$t('views.layout.Dialog.Feedback.4808a609ca9566f26fb2969c64929090')"
    :width="700"
    :mask-closable="false"
    is-show-cancel
    :padding="30"
    @submit="handleSubmit"
    @cancel="handleClose"
    @after-visible-change="afterClose"
  >
    <div class="dialog-body">
      <div class="mb10">
        {{
          $t('views.layout.Dialog.Feedback.9a4782d1b6db31f08927f6716f5d6de5')
        }}
      </div>
      <DynamicsForm
        :model="formModel"
        :setting="feedbackSetting"
        :label-width="110"
        layout="labelTop"
        :group-collapse="false"
        tips-placement="left"
      />
    </div>
    <div v-if="IS_DOMESTIC" class="feedback-info">
      <div class="feedback-info-item">
        <span>{{
          $t('views.layout.Dialog.Feedback.255aabe78f36c5b1b3b4f0d3eee563ed')
        }}</span>
        <span>{{ feedbackEmail }}</span>
      </div>
      <div class="feedback-info-item">
        <span>{{
          $t('views.layout.Dialog.Feedback.ce5fe09a3e4aa2a18e9ae685e67f6b3a')
        }}</span>
        <span class="mr12">400-008-8182</span>
        <span>010-64718828</span>
      </div>
    </div>
    <div v-if="!IS_DOMESTIC">
      <span class="mr4">{{
        $t('views.layout.Dialog.CancelAccount.038235a36c3418bd90e9cb505c92dced')
      }}</span>
      <span class="mr12">agents-service@dyna.ai</span>
      <span>support@dyna.ai</span>
    </div>
  </EditDialog>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { computed, defineComponent, ref } from 'vue';
import { DynamicsForm } from '@koi-design/vix-components';
import { message } from '@koi-design/uxd-ui';
import { feedBackApi } from '@api/common';
import isBaiyuHardwareEnabled from '@libs/isBaiyuHardwareEnabled';

export default defineComponent({
  name: 'CreateDataSet',
  components: {
    DynamicsForm
  },
  emits: ['success'],
  setup() {
    const { t } = useI18n();
    const feedbackEmail = computed(() =>
      isBaiyuHardwareEnabled() ? 'baiyu@brgroup.com' : 'rc_agentos@brgroup.com'
    );
    const showModal = ref(false);
    const formModel = ref({
      content: '',
      contact_information: '',
      feedback_source: 2
    });
    const show = (flag = true) => {
      showModal.value = flag;
    };
    const feedbackSetting = [
      {
        label: t(
          'views.layout.Dialog.Feedback.e75d339dec9e42b8ec120314a9e81fd5'
        ),
        name: 'content',
        type: 'textarea',
        props: {
          maxlength: 2000,
          showWordLimit: true,
          placeholder: t(
            'views.layout.Dialog.Feedback.6d495d9f8846716c05b9909718241f38'
          ),
          style: 'height: 120px'
        }
      },
      {
        label: t(
          'views.layout.Dialog.Feedback.722033d2724e003e4537d7df0e9d4360'
        ),
        type: 'input',
        name: 'contact_information',
        props: {
          maxlength: 100,
          placeholder: t(
            'views.layout.Dialog.Feedback.38101c86b5fce990212f420d0f588559'
          )
        }
      }
    ];
    const handleSubmit = async () => {
      if (!formModel.value.content.trim()) {
        message.error(
          t('views.layout.Dialog.Feedback.b83c8780c7cf114e1d7fcf9d75cb7cd3')
        );
        return;
      }
      const res = await feedBackApi({
        ...formModel.value
      });
      if (res) {
        showModal.value = false;
      }
    };
    const afterClose = visible => {
      if (!visible) {
        formModel.value = {
          content: '',
          contact_information: '',
          feedback_source: 2
        };
      }
    };
    const handleClose = () => {
      showModal.value = false;
    };
    return {
      showModal,
      show,
      formModel,
      feedbackSetting,
      feedbackEmail,
      handleSubmit,
      handleClose,
      afterClose
    };
  }
});
</script>

<style scoped lang="less">
.feedback-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  .feedback-info-item {
    display: flex;
  }
}
</style>
